<div class="p-3">
    <div class="pt-1 flex justify-content-between">
        <div class="commerce-header align-content-center">Overview</div>
        <div class="flex">
            <p-button class="mr-3 commerce-btn" label="View all Txs" [outlined]="true" (click)="showTransactions()" />
            <!-- <p-button label="Export CSV" /> -->
            <p-button label="Upload Products"  class="commerce-btn" [outlined]="true" (click)="showUploadProducts()"/>
        </div>
    </div>
    
    <hr class="mt-3 delimiter">
    
    <div class="flex mt-3">
        <div class="flex-1">
            <div class="sidebar-text sidebar-left-label mt-3">First TX Date</div>
            <div class="sidebar-text sidebar-left-label mt-3">Total Amount Availed</div>
            <div class="sidebar-text sidebar-left-label mt-3">Balance Owed</div>
            <div class="sidebar-text sidebar-left-label mt-3">Last Deduction</div>
            <div class="sidebar-text sidebar-left-label mt-3">Next Deduction</div>
        </div>
        <div class="flex-1">
            <div class="sidebar-text vehicle-list-val mt-3">
                {{!commerceOverview || !commerceOverview.FirstTXDate ? '--' : commerceOverview.FirstTXDate | date: 'MMM dd, yyyy'}}
            </div>
            <div class="sidebar-text vehicle-list-val mt-3">
                {{!commerceOverview || !commerceOverview.TotalAmountAvailed ? '--' : commerceOverview.TotalAmountAvailed | currency: 'PHP' : 'symbol' : '1.2-2'}}
            </div>
            <div class="sidebar-text vehicle-list-val mt-3">
                {{!commerceOverview || !commerceOverview.Balance ? '--' : commerceOverview.Balance | currency: 'PHP' : 'symbol' : '1.2-2'}}
            </div>
            <div class="sidebar-text vehicle-list-val mt-3">
                {{!commerceOverview || !commerceOverview.LastDeduction ? '--' : commerceOverview.LastDeduction | date: 'MMM dd, yyyy'}}
            </div>
            <div class="sidebar-text vehicle-list-val mt-3">
                {{!commerceOverview || !commerceOverview.NextDeduction ? '--' : commerceOverview.NextDeduction | date: 'MMM dd, yyyy'}}
            </div>
        </div>
    </div>

    <hr class="mt-3 delimiter">

    <div class="pt-1 mb-2 flex justify-content-between">
        <div class="commerce-header align-content-center">Products Availed</div>
        <div class="flex">
            <!-- <p-button class="mr-3" label="Filter" icon="pi pi-filter" iconPos="right" [outlined]="true" /> -->
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" class="search-input"
                       [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                       placeholder="Search..." />
            </span>
            <!-- <p-button (click)="showAddProduct()" class="ml-2 commerce-btn" label="Add Product" /> -->
        </div>
    </div>

    <p-table #xpressUsersGrid
                [columns]="productsAvailedCols"
                [value]="driverCommerce"
                [lazy]="true"
                [loading]="loading"
                responsiveLayout="scroll" dataKey="Id"
                (onLazyLoad)="handleLazyLoad($event)"
                [showFirstLastIcon]="false"
                [resizableColumns]="true"
                [columnResizeMode]="'expand'"
                [autoLayout]="true"
                [styleClass]="'p-datatable-gridlines'"
                [scrollable]="true"
                [scrollHeight]="'flex'"
                [paginator]="true"
                [(first)]="first"
                [rows]="rowsPerPage"
                [rowsPerPageOptions]="rowsPerPageOptions"
                [totalRecords]="totalRecords"
                [style]="{height: 'calc(33vh)'}">
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of productsAvailedCols"
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="false"
                    [style.width]="col.width">
                    {{col.header}}
                    <p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td>
                    <span class="status" [ngStyle]="getStatusStyles(product.Status)">{{getStatusText(product.Status)}}</span>
                </td>
                <td>
                    <span>{{product.ProgramType === 1 ? 'Gadget' : 'Vehicle'}} Program</span>
                </td>
                <td>
                    <span>{{product.ProductId}}</span>
                </td>
                <td>
                    <a class="cursor-pointer" target="_blank" (click)="getProductDetails(product.CommerceId)">{{product.ProductName}}</a>
                     <!-- <span>{{product.ProductName}}</span> -->
                </td>
                <td>
                    <span>{{product.DateAvailed | date: 'MMM dd, yyyy'}}</span>
                </td>
                <td>
                    <span>{{product.StartDate ? (product.StartDate | date: 'MMM dd, yyyy') : 'N/A'}}</span>
                </td>
                <td>
                    <span>{{product.ProductPrice | currency: 'PHP' : 'symbol' : '1.2-2'}}</span>
                </td>
            </tr>
        </ng-template>
        <ng-template class="mt-3" pTemplate="paginatorleft" let-state>
            <div *ngIf="driverCommerce.length > 0">
                Showing {{first + 1}} to {{first + driverCommerce.length}} of {{totalRecords}} entries
            </div>
        </ng-template>
    </p-table>

    <div class="flex-row w-full" *ngIf="driverCommerce.length < 1">
        <div class="col-12 text-center align-content-center h-30rem commerce-section">
            <img src="/XpressApp/assets/images/commerce/no-product.png" class="mb-1 no-product-img" />
            <div class="product-not-title">There are no existing product. Create one!</div>
        </div>
    </div>
</div>

<add-availed-product-dialog 
    *ngIf="isAddProductVisible" 
    [driver]="driver" 
    [visible]="isAddProductVisible"
    (hideAddProduct)="hideAddProduct($event)"
    (saveAddedProduct)="hideProduct($event)">
</add-availed-product-dialog>

<upload-products-dialog
    *ngIf="isUploadProductsVisible"
    [visible]="isUploadProductsVisible"
    [riderId]="riderId"
    (hideDialog)="hideUploadProducts($event)"
    (uploadSuccess)="onUploadSuccess($event)">
</upload-products-dialog>
